import api from "@/services/api"
import ScheduleSetting from "@/types/scheduleSettings"

class ApiScheduleSettings {
	private get axios () {
		return api.getAxios()
	}

	public async ScheduleSettingsList (): Promise<ScheduleSetting> {
		return (await this.axios.get("/schedule/settings")).data
	}

	public async ScheduleSettingsSave (scheduleSettings: ScheduleSetting): Promise<void> {
		await this.axios.post("/schedule/saveSettings", scheduleSettings)
	}
}

const apiScheduleSettings = new ApiScheduleSettings()

export default apiScheduleSettings
